import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-dropdown-standard',
  templateUrl: './dropdown-standard.component.html',
  styleUrls: ['./dropdown-standard.component.css']
})
export class DropdownStandardComponent implements OnChanges {

  @Input() dropDownList: IDropdownItem[];
  @Output() onItemSelected = new EventEmitter<any>();
  @Input() selectionDescription: string;
  @Input() showInitialSelectedValue: boolean;
  selectedValue: any;


  ngOnChanges(): void {
    if (this.showInitialSelectedValue) this.selectedValue = this.dropDownList[0];
  }

  public handleSelection(selection: IDropdownItem): void {
    this.selectionDescription = selection.GetDescription();
    this.onItemSelected.emit(selection);
  }

  compareSelectedValue(item1, item2) {
    return item1 == item2;
  }
}

export interface IDropdownItem {
  GetDescription(): string;
};
